/**
 * Created by AdiosMU on 2019/1/17.
 */
import Vue from 'vue'
export default new Vue



// WEBPACK FOOTER //
// ./src/assets/bus.js